import React, { useState, useEffect } from 'react'
import {
	IonText,
	IonButton,
	IonItem,
	IonCheckbox,
	IonSpinner,
} from '@ionic/react'

const GoalsSelection = ({ goals, selectedGoals, onGoalsSelected, isLoading, error }) => {
	const [localSelectedGoals, setLocalSelectedGoals] = useState([])

	// Initialize with pre-selected goals from API
	useEffect(() => {
		if (goals && goals.length > 0) {
			const preSelected = goals
				.filter(goal => goal.answers && goal.answers.length > 0)
				.map(goal => goal.id)
			setLocalSelectedGoals(preSelected)
		}
	}, [goals])

	const handleGoalToggle = (goalId) => {
		setLocalSelectedGoals(prev => {
			if (prev.includes(goalId)) {
				return prev.filter(id => id !== goalId)
			} else {
				return [...prev, goalId]
			}
		})
	}

	const handleSubmit = () => {
		onGoalsSelected(localSelectedGoals)
	}

	const isSubmitDisabled = localSelectedGoals.length === 0 || isLoading

	if (isLoading && goals.length === 0) {
		return (
			<div className="loading-container">
				<IonSpinner name="crescent" />
				<IonText>Caricamento obiettivi...</IonText>
			</div>
		)
	}

	return (
		<div>
			<h1>Scegli i tuoi obiettivi di benessere</h1>
			<h6>Puoi selezionarne fino a 3 e ordinarli per importanza.</h6>
			
			{error && (
				<IonText color="danger" className="error">
					{error}
				</IonText>
			)}

			{goals.map((goal, index) => (
				<IonItem key={goal.id} className="no-padding-item">
					<div className="option-container">
						<IonCheckbox
							checked={localSelectedGoals.includes(goal.id)}
							onIonChange={() => handleGoalToggle(goal.id)}
						>
							{goal.name}
						</IonCheckbox>
						{goal.description && (
							<div className="option-description">
								{goal.description}
							</div>
						)}
					</div>
				</IonItem>
			))}

			<div className="buttons">
				<IonButton
					shape="round"
					onClick={handleSubmit}
					disabled={isSubmitDisabled}
					color="primary"
					expand="full"
				>
					{isLoading ? <IonSpinner name="crescent" /> : 'Avanti'}
				</IonButton>
			</div>
		</div>
	)
}

export default GoalsSelection
